import React from 'react';

import { StyledStatusLabel } from '../../../common/StatusLabel';
import { WorkflowListItem } from '../Workflow.interface';

export interface WorkflowApiLevelProps {
  apiLevel: WorkflowListItem['apiLevel'];
  className?: string;
}

const WorkflowApiLevelLabel: React.FC<WorkflowApiLevelProps> = props => {
  const { apiLevel, className } = props;
  const classes = [apiLevel === 1 ? 'to-do' : 'warn'];
  className && classes.push(className);
  return (
    <StyledStatusLabel
      className={classes.join(' ')}
      style={{ textTransform: 'unset' }}
    >
      API v{apiLevel}
    </StyledStatusLabel>
  );
};

export default WorkflowApiLevelLabel;
